import { render, staticRenderFns } from "./NbNewUploaderPdfPreviewToolbar.vue?vue&type=template&id=bfaddb94&scoped=true&lang=pug"
import script from "./NbNewUploaderPdfPreviewToolbar.vue?vue&type=script&lang=ts"
export * from "./NbNewUploaderPdfPreviewToolbar.vue?vue&type=script&lang=ts"
import style0 from "./NbNewUploaderPdfPreviewToolbar.vue?vue&type=style&index=0&id=bfaddb94&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaddb94",
  null
  
)

export default component.exports